import { useSelector } from 'react-redux';
import {
  getCurrentAccount,
  selectAccountUsersData,
  selectIsSellFromHomeRestricted,
} from '../../store/selectors/accountSelectors';
import { selectAuthUser } from '../../store/selectors/userSelectors';
import { accountTypes, accountTypeKeys } from '../enum/api/accountTypes';
import { accountCountryTypes } from '../enum/api/accountCountryTypes';
import { parseEnumType } from '../helpers/enumMappers';
import config from '../../config';
import { GS } from '../../constants/Brokers';

const useSellFromHomeEligibility = () => {
  const account = useSelector(getCurrentAccount);
  const isSellFromHomeRestricted = useSelector(selectIsSellFromHomeRestricted);
  const authUser = useSelector(selectAuthUser);
  const accountUsers = useSelector(selectAccountUsersData);

  const isGS = config.brokerTheme === GS;
  const isNonUS = account?.Country === accountCountryTypes.NonUS;
  const accountType = parseEnumType(accountTypeKeys, account?.AccountType);
  const isBasicAccount = accountType === accountTypes.Basic;
  const isIraOrUtmaAccount =
    accountType === accountTypes.IRA || accountType === accountTypes.UTMA;
  const isPendingAccount =
    account?.AccountStatus === 4 ||
    account?.AccountStatus === 1 ||
    account?.AccountStatus === 7;
  // Subset of isPendingAccount: specifically the RequiresAttention (4, "RA")
  // and Err (7, "ERR") statuses — not the plain Pending (1) status. See
  // accountStatusTypesArray in nagDashboardContants.js for the status names.
  const isErrOrRaAccount =
    account?.AccountStatus === 4 || account?.AccountStatus === 7;
  const currentAccountUser = Array.isArray(accountUsers)
    ? accountUsers.find((user) => user?.UserUid === authUser?.UserUid)
    : null;
  // Sub-user on the account (IsPrimaryUser false), not Joint account type.
  // Delivery-only (Basic) must show the verify-account modal instead — do not
  // treat those users as joint sub-users even when IsPrimaryUser is false.
  const isJointSubUser =
    !isBasicAccount && currentAccountUser?.IsPrimaryUser === false;

  return {
    isGS,
    isNonUS,
    isBasicAccount,
    isIraOrUtmaAccount,
    isJointSubUser,
    isPendingAccount,
    isErrOrRaAccount,
    isSellFromHomeRestricted,
  };
};

export default useSellFromHomeEligibility;
